import IconMap from '../../UI/icon/IconMap';

const defaults = {
	icon: IconMap.circle,
	iconColor: '#000000',
};
const canvasThickness = [
	{
		...defaults,
		label: '2pt',
		value: 2,
		iconSize: 4,
	},
	{
		...defaults,
		label: '5pt',
		value: 5,
		iconSize: 8,
	},
	{
		...defaults,
		label: '10pt',
		value: 10,
		iconSize: 12
	},
	{
		...defaults,
		label: '20pt',
		value: 20,
		iconSize: 16
	},
	{
		...defaults,
		label: '30pt',
		value: 30,
		iconSize: 20
	},
	{
		...defaults,
		label: '50pt',
		value: 50,
		iconSize: 24
	},
];

export default canvasThickness;